module.exports = __webpack_public_path__ + "static/img/qd_banner_tit.8956d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve/qd_banner_tit.png
// module id = I/UV
// module chunks = 1